export default {
  rootImg: '/assets/components',
  swiftype: {
    api: {
      url: 'https://search-api.swiftype.com',
      enginekey: {
        en: '4oF_QrqxnWcsuRjkhpe6',
        fr: '1NDZFjyzBzGemrWMmxR3',
        de: 'CiyVUuEzJMz_UP4cZfxm',
        admin: 'Ze5f8sonvozm4PBuZ47f',
      },
    },
  },
  rootCardImgs: 'https://www.thethinkingtraveller.com',
  rootMediaLib: 'https://www.thethinkingtraveller.com/Media/',
  limitSearchResults: 12,
  googlemaps: {
    key: 'AIzaSyBZg8xJj6H4JDo1oAsPPFC_8xYtL-CI9eM',
  },
  cookie: {
    neverExpire: 2147483647,
  },
  results: {
    pricerangedelay: 500,
  },

  PriceConfigMaxAllowables: {
    People: 50,
    ExtraBabies: 4,
  },

  // MAPPING THE PAGE IDs TO DISPLAY THE CORRECT DYNAMIC CONTENT ACCORDING TO THE REGION (ID = LOCATION.JS, cmsID = PAGE ID IN CMS, weatherID = WEATHER PAGE ID IN CMS)
  // ADD REGIONS AS NEEDED BUT PLEASE ASK ANGEL TO UPDATE CONTENT JS FILES WITH NEW REGION IDs ETC
  regions: [
    {
      name: 'italy',
      // id: 10,
      cmsID: 89,
      // guideID: '',
      // experienceID: '',
      // weatherID: ''
    },
    {
      name: 'sicily',
      id: 1,
      destinationID: 1,
      cmsID: 26,
      guideID: 33,
      experienceID: 322,
      weatherID: 111,
    },
    {
      name: 'puglia',
      id: 4,
      destinationID: 4,
      cmsID: 28,
      guideID: 34,
      experienceID: 106,
      weatherID: 113,
    },
    // {
    //   name: 'minor_italian_islands',
    //   id: 9,
    //   destinationID: 9,
    //   cmsID: 835,
    //   guideID: 846,
    //   experienceID: 847,
    //   weatherID: 851,
    // },
    {
      name: 'france',
      // id: 11,
      cmsID: 92,
      // guideID: '',
      // experienceID: '',
      // weatherID: ''
    },
    {
      name: 'corsica',
      id: 8,
      destinationID: 8,
      cmsID: 30,
      guideID: 36,
      experienceID: 107,
      weatherID: 115,
    },
    {
      name: 'greek_islands',
      id: 5,
      destinationID: 5,
      cmsID: 91,
      // guideID: '',
      // experienceID: '',
      // weatherID: ''
    },
    {
      name: 'greece',
      id: 5,
      destinationID: 5,
      cmsID: 1087,
    },
    {
      name: 'corfu',
      id: 16,
      destinationID: 16,
      cmsID: 97,
      guideID: 118,
      experienceID: 554,
      weatherID: 494,
    },
    {
      name: 'paxos_and_antipaxos',
      id: 27,
      destinationID: 27,
      cmsID: 98,
      guideID: 445,
      experienceID: 555,
      weatherID: 495,
    },
    {
      name: 'meganissi',
      id: 23,
      destinationID: 23,
      cmsID: 99,
      guideID: 446,
      experienceID: 556,
      weatherID: 496,
    },
    {
      name: 'kastos',
      id: 19,
      destinationID: 19,
      cmsID: 100,
      guideID: 447,
      experienceID: 557,
      weatherID: 497,
    },
    {
      name: 'lefkada',
      id: 22,
      destinationID: 22,
      cmsID: 101,
      guideID: 448,
      experienceID: 558,
      weatherID: 498,
    },
    {
      name: 'alonissos',
      id: 12,
      destinationID: 12,
      cmsID: 102,
      guideID: 449,
      experienceID: 559,
      weatherID: 466,
    },
    {
      name: 'skopelos',
      id: 31,
      destinationID: 31,
      cmsID: 103,
      guideID: 450,
      experienceID: 485,
      weatherID: 467,
    },
    {
      name: 'zakynthos',
      id: 35,
      destinationID: 35,
      cmsID: 994,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    // {
    //   name: 'spain',
    //   id: 12,
    //   cmsID: 940,
    // },
    // {
    //   name: 'mallorca',
    //   id: 10,
    //   destinationID: 10,
    //   cmsID: 943,
    //   guideID: 944,
    //   experienceID: 952,
    //   weatherID: 945,
    // },
    // {
    //   name: 'athens_riviera',
    //   id: 15,
    //   destinationID: 15,
    //   cmsID: 1235,
    //   guideID: 995,
    //   experienceID: 997,
    //   weatherID: 999,
    // },
    {
      name: 'hydra',
      id: 18,
      destinationID: 18,
      cmsID: 1116,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'spetses',
      id: 32,
      destinationID: 32,
      cmsID: 1167,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'patmos',
      id: 26,
      destinationID: 26,
      cmsID: 1210,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'aegina',
      id: 11,
      destinationID: 11,
      cmsID: 1109,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'tinos',
      id: 34,
      destinationID: 34,
      cmsID: 1123,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'syros',
      id: 33,
      destinationID: 33,
      cmsID: 1122,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'mykonos',
      id: 24,
      destinationID: 24,
      cmsID: 1121,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'kea',
      id: 20,
      destinationID: 20,
      cmsID: 1150,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'paros',
      id: 25,
      destinationID: 25,
      cmsID: 1120,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'antiparos',
      id: 13,
      destinationID: 13,
      cmsID: 1119,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'porto_heli',
      id: 28,
      destinationID: 28,
      cmsID: 1126,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'kefalonia',
      id: 21,
      destinationID: 21,
      cmsID: 1124,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'skiathos',
      id: 30,
      destinationID: 30,
      cmsID: 1125,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'evia',
      id: 17,
      destinationID: 17,
      cmsID: 1115,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
    {
      name: 'serifos',
      hi: '',
      id: 29,
      destinationID: 29,
      cmsID: 1205,
      guideID: 995,
      experienceID: 997,
      weatherID: 999,
    },
  ],

  breakpoints: {
    mobile: 767, // max breakpoint for mobile 0 > screenWidth < 768
    tablet: 1023, // max breakpoint for tablet 768 >= screenWidth < 1025
    desktop: 1024, // max breakpoint for desktop 1025 >= screenWidth < infinity
    desktop_lg: 1746,
    desktop_md: 1440,
    sca_mobile: 950,
    sca_tablet: 1380, // things start to look messy around here in the sca - we need to work on all screen sizes
    sca_desktop: 1381,
  },

  googMapStyle: [{
    featureType: 'administrative',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    },
    ],
  }, {
    featureType: 'administrative',
    elementType: 'labels',
    stylers: [{
      visibility: 'on',
    },
    ],
  }, {
    featureType: 'administrative.province',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    },
    ],
  }, {
    featureType: 'administrative.locality',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    },
    ],
  }, {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text',
    stylers: [{
      saturation: '-8',
    },
    ],
  }, {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [{
      color: '#f9f1dd',
    },
    ],
  }, {
    featureType: 'landscape',
    elementType: 'labels',
    stylers: [{
      visibility: 'simplified',
    }, {
      color: '#a12b2b',
    },
    ],
  }, {
    featureType: 'poi',
    elementType: 'all',
    stylers: [{
      visibility: 'simplified',
    },
    ],
  }, {
    featureType: 'poi.business',
    elementType: 'all',
    stylers: [{
      visibility: 'off',
    },
    ],
  }, {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{
      color: '#c5dac6',
    },
    ],
  }, {
    featureType: 'poi.park',
    elementType: 'labels',
    stylers: [{
      visibility: 'on',
    }, {
      lightness: '46',
    }, {
      saturation: '-95',
    },
    ],
  }, {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [{
      visibility: 'simplified',
    },
    ],
  }, {
    featureType: 'road',
    elementType: 'all',
    stylers: [{
      lightness: 20,
    }, {
      visibility: 'simplified',
    },
    ],
  }, {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{
      visibility: 'simplified',
    }, {
      color: '#c5c6c6',
    },
    ],
  }, {
    featureType: 'road.highway',
    elementType: 'labels',
    stylers: [{
      hue: '#ff9600',
    }, {
      saturation: '75',
    },
    ],
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text',
    stylers: [{
      hue: '#ff0000',
    }, {
      visibility: 'on',
    },
    ],
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{
      hue: '#ff0000',
    },
    ],
  }, {
    featureType: 'road.highway',
    elementType: 'labels.text.stroke',
    stylers: [{
      hue: '#ff0000',
    },
    ],
  }, {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{
      color: '#e4d7c6',
    },
    ],
  }, {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{
      color: '#fbfaf7',
    },
    ],
  }, {
    featureType: 'water',
    elementType: 'all',
    stylers: [{
      visibility: 'on',
    }, {
      color: '#b7d1e6',
    },
    ],
  },
  ],
  vanillacookie: {
    autorun: true,
    force_consent: true,
    // current_lang: 'en',
    autoclear_cookies: true,
    page_scripts: true,
    onFirstAction(user_preferences, cookie) {
      // Start exponea only after user has accepted the Performance and Analytics category
      if (user_preferences.accepted_categories.includes('analytics')) {
        exponea.start();
      }
    },
    gui_options: {
      consent_modal: {
        layout: 'box', // box/cloud/bar
        position: 'middle center', // bottom/middle/top + left/right/center
        transition: 'zoom', // zoom/slide
        swap_buttons: false, // enable to invert buttons
      },
      settings_modal: {
        layout: 'box', // box/bar
        position: 'center', // left/right
        transition: 'zoom', // zoom/slide
      },
    },

    languages: {
      en: {
        consent_modal: {
          title: 'Hello, welcome to The Thinking Traveller',
          description: 'We use cookies and similar technologies for website performance, analysis, and targeting in order to provide you with the best online experience.',
          primary_btn: {
            text: 'Accept',
            role: 'accept_all', // 'accept_selected' or 'accept_all'
          },
          secondary_btn: {
            text: 'Settings',
            role: 'settings', // 'settings' or 'accept_necessary'
          },
        },
        settings_modal: {
          title: 'Cookie preferences',
          save_settings_btn: 'Save settings',
          accept_all_btn: 'Accept all',
          reject_all_btn: 'Reject all', // optional, [v.2.5.0 +]
          cookie_table_headers: [
            { col1: 'Name' },
            { col2: 'Domain' },
            // { col3: 'Expiration' },
            { col4: 'Description' },
            // { col5: 'Type' }
          ],
          blocks: [{
            title: 'Cookie usage',
            description: 'By using our website, you agree to the use of cookies and other technologies as set out on our <a target="_blank" href="/cookie-information">cookie policy</a>. Some users may like more individual control over their visit to our website and we would encourage them to do this by amending their privacy settings accordingly, normally controlled within your browser. If you do not agree to such use, please avoid using this website. For more information, see our <a target="_blank" href="/privacy-policy">privacy policy</a>.',
          }, {
            title: 'Strictly necessary cookies',
            description: 'We use cookies to improve your experience of our site and to store preferences that you may have so that you don\'t have to keep applying them. The cookies we use do not store information that can be personally identifiable and they cannot harm your computer.',
            toggle: {
              value: 'necessary',
              enabled: true,
              readonly: true,
            },
          }, {
            title: 'Performance and analytics cookies',
            description: 'These cookies collect information about how you use the website and help us understand how customers find our website. All data is anonymized and cannot be used to identify you.',
            toggle: {
              value: 'analytics',
              enabled: false,
              readonly: false,
            },
            cookie_table: [
              {
                col1: 'Google',
                col2: 'analytics.google.com',
                col3: '',
                col4: 'We use Google cookies to understand how customers find our website and also to analyse the success of our advertising campaigns on their sites.',
                col5: '',
              },
              {
                col1: 'Livechat',
                col2: 'livechatinc.com',
                col3: '',
                col4: 'Our instant messaging chat feature on our site remembers who you are should you chat to us for help or enquiries so we can retain past chat logs.',
                col5: '',
              },
              {
                col1: 'Algolia',
                col2: 'algolia.com',
                col3: '',
                col4: 'We use Algolia to serve our site search functionality and it uses site behaviour to improve your search results.',
                col5: '',
              },
              {
                col1: 'Bloomreach',
                col2: 'app.exponea.com',
                col3: '',
                col4: 'We use Bloomreach Engagement to analyse and segment website users and serve A/B testing and other website features.',
                col5: '',
              },
              {
                col1: 'Contentsquare',
                col2: 'app.contentsquare.com',
                col3: '',
                col4: 'ContentSquare is a solution which aggregates usage and frequency data to improve user experience. Statistics created are anonymous. To be excluded from this monitoring, please <a onclick="window._uxa.push([\'optout\']); return false;" style="cursor: pointer;">click here</a>.',
                col5: '',
              },
            ],
          }, {
            title: 'Targeting and Advertising cookies',
            description: 'Our advertising cookies use standard remarking code to remind you who we are after you leave our site.',
            toggle: {
              value: 'advertising',
              enabled: false,
              readonly: false,
            },
            cookie_table: [
              {
                col1: 'Facebook',
                col2: 'facebook.com',
                col3: '',
                col4: 'You may see our ad banners on other pages you visit after leaving our site.',
                col5: '',
              },
            ],
          }, {
            title: 'More information',
            description: 'For any queries in relation to my policy on cookies and your choices, please see our <a target="_blank" href="/privacy-policy">privacy policy</a>.',
          },
          ],
        },
      },
    },
  },
};
